import script from "./BssMapEventInfobox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMapEventInfobox.vue?vue&type=script&lang=ts&setup=true"

import "./BssMapEventInfobox.vue?vue&type=style&index=0&id=0a64cd9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a64cd9f"]])

export default __exports__